import axios from "@/libs/api.request";
export const getList = (params) => {
  return axios.request({
    url: "/finance/reimburse/type",
    method: "get",
    params,
  });
};


export const detail = (id) => {
  return axios.request({
    url: "/finance/reimburse/tpl/"+id,
    method: "get",
  });
};

export const save = (data) => {
  return axios.request({
    url: "/finance/reimburse/tpl/"+data.id,
    method: "post",
		data
  });
};

export const add = (data) => {
  return axios.request({
    url: '/finance/reimburse/type',
    method: "post",
		data
  });
};

export const update = (data) => {
  return axios.request({
    url: '/finance/reimburse/type/'+data.id,
    method: "put",
		data
  });
};

export const del = (data) => {
  return axios.request({
    url: '/finance/reimburse/type/'+data.id,
    method: "delete",
		data
  });
};